import { createSelector } from '@reduxjs/toolkit'

import { selectDownload } from './selectDownload'
import { selectDownloadSpeed } from './selectDownloadSpeed'

// Estimate remaining time in seconds
export const selectEstimatedTimeRemaining = createSelector(
  selectDownload,
  selectDownloadSpeed,
  (download, speed) => {
    if (!speed || !download.remainingBytes || download.remainingBytes <= 0) return null

    return Math.round(download.remainingBytes / speed) // seconds
  }
)
